// @flow

export const SELECT_CHIP = 'select:searchChip';
export const SELECT_NARROW_FILTER = 'select:searchNarrowFilter';
export const RESET_INIT = 'reset:Init';
export const TOGGLE_ADVANCE_OPTION = 'toggle:Options';
export const APPLY_ADVANCE_FILTER = 'apply:Adv';
